import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { CheckboxState } from 'frontcore/views/selection-control/types'
import { computed } from 'vue'

interface Props {
  disabled?: boolean
  value: CheckboxState
}

type Emits = (e: 'input:value', value: Props['value']) => void


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxIcon',
  props: {
    disabled: { type: Boolean, default: false },
    value: {}
  },
  emits: ["input:value"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const stateIcon = computed(() => {
  switch (props.value) {
  case CheckboxState.UNCHECKED:
    return 'CheckboxUnchecked'
  case CheckboxState.CHECKED:
    return 'CheckboxCheckedFill'
  case CheckboxState.INDETERMINATE:
    return 'CheckboxIndeterminate'
  }
  return 'CheckboxIndeterminate'
})

const color = computed(() => props.disabled ? 'tw-fill-core-neutral-cold-80' : 'tw-fill-core-primary-10')

const updateValue = () => {
  if (props.disabled) return
  let newValue = CheckboxState.UNCHECKED
  switch (props.value) {
  case CheckboxState.UNCHECKED:
    newValue = CheckboxState.CHECKED
    break
  case CheckboxState.CHECKED:
    newValue = CheckboxState.UNCHECKED
    break
  case CheckboxState.INDETERMINATE:
    newValue = CheckboxState.UNCHECKED
    break
  }
  emit('input:value', newValue)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SVGIcon, {
    class: _normalizeClass(["text-core-primary-30", {'pointer': !_ctx.disabled}]),
    iconName: stateIcon.value,
    colorClass: color.value,
    onClick: updateValue
  }, null, 8, ["class", "iconName", "colorClass"]))
}
}

})